import { Box, Skeleton, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import StyledBox from 'views/rebranded-module/common/components/UI/TourFootNote/TourFootNote.styles';

const TourFootNoteSkeleton: FC<any> = () => {
  const { t } = useTranslation('common_tour_footnote');
  return (
    <StyledBox>
      <Box className="TFNInfoContainer">
        <InfoOutlinedIcon className="TFNInfoIcon" />
      </Box>
      <Box
        p={2}
        className="TFNTextContainer"
        style={{
          width: '100%',
        }}>
        <Skeleton
          variant="rectangular"
          height={20}
          style={{ marginBottom: 4 }}
        />
        <Skeleton
          variant="rectangular"
          height={20}
          style={{ marginBottom: 4 }}
        />
        <Skeleton variant="rectangular" height={20} />
      </Box>
    </StyledBox>
  );
};

export { TourFootNoteSkeleton };
